<template>
  <div class="main-wrapper">
    <el-tabs v-model="activeName">
      <el-tab-pane label="发票申请" name="apply">
        <apply-invoice />
      </el-tab-pane>
      <el-tab-pane label="开票记录" name="list">
        <list-invoice />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ApplyInvoice from './components/invoices/ApplyInvoice.vue';
import ListInvoice from './components/invoices/ListInvoice.vue';

export default defineComponent({
  components: {
    ApplyInvoice,
    ListInvoice,
  },
  data() {
    return {
      activeName: 'apply',
    };
  },
});
</script>
